<!-- eslint-disable -->
<template lang="pug">
    .table-responsive-container
        .table-responsive
            table.points__table
                thead.points__thead
                    tr.points__tr--border
                        td.points__td(v-if="user.type !== 'student'")
                            | {{ $i18n.t('common.common_userType_student') }}
                        td.points__td
                            | {{ $i18n.t('historyTable.historyTable_title_dateScoring') }}
                        td.points__td
                            | {{ pointsRealName }}
                        td.points__td
                            | {{ $i18n.t('historyTable.historyTable_title_source') }}
                tbody
                    motivation-points-preview(v-for="record in items" :record="record" :key="record.id")
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import MotivationPointsPreview from './Preview.vue';
    const MAP_MOTIVATION = 'map';

    export default {
        props: ['items'],
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            pointsRealName () {
                return this.items && this.items[0].motivationType === MAP_MOTIVATION
                    ? this.$i18n.t('miles.miles_historyTable_miles')
                    : this.$i18n.t('points.points_detectiveTable_points')
            }
        },
        components: {
            MotivationPointsPreview
        }
    }
</script>

<style lang="scss" scoped>
    .table-responsive-container {
        display: grid;
    }

    .table-responsive {
        overflow-x: auto;
    }

    .points__table {
        margin: 30px 0;
        width: 100%;
        text-align: left;
        border-collapse: collapse;
    }

    .points__thead {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        background-color: #E6E6F8;
    }

    .points__td {
        padding: 13px 12px;
        @include media($md) {
            padding: 10px 30px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }
</style>
